<template>
  <div class="full-wrapper">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full report">
        <el-row class="title-bar" type="flex" justify="space-between">
          <el-col :span="12" class="switch-wrapper">
            최다 출력 순
            <el-switch v-model="orderType" active-value="date" inactive-value="count" @change="changeView"></el-switch>
            최신 생성 순
            <el-button @click="deleteReport"  class="mr-l10">삭제</el-button>
          </el-col>
          <el-col :span="12" class="btn-group-right">
            <el-input v-if="viewType === 'icon'" style="width: 200px;" placeholder="보고서 명을 입력해주십시오" v-model="searchValue" @keyup.native.enter="searchReport"></el-input>
            <w-header-search-button v-else-if="viewType === 'detail'" @click="showSearchTool = !showSearchTool"></w-header-search-button>
            <el-button label="icon" @click="viewType = 'icon'" type="content" size="mini"  class="customised-icon grid"></el-button>
            <el-button label="detail" @click="viewType = 'detail'" type="content" size="mini"  class="customised-icon list"></el-button>
            <!-- <el-button label="icon" @click="viewType = 'icon'"><i class="el-icon-menu"></i></el-button>
            <el-button label="detail" @click="viewType = 'detail'"><i class="fas fa-list-ul"></i></el-button> -->
          </el-col>
        </el-row>
        <hr v-show="viewType === 'icon'" />
        <w-report-icon-list v-show="viewType === 'icon'" ref="iconView" :order-type="orderType" :view-type="viewType" :active="active" :report-search-value="reportSearchValue" />
        <w-report-detail-table v-show="viewType === 'detail'" ref="detailView" :order-type="orderType" :view-type="viewType" :active="active" :show-search-tool="showSearchTool" />
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import ScrollbarMixin from '@/mixins/scrollbar';
import reportApi from '@/api/report/report';
import msgUtil from '@/utils/message';
import WReportIconList from './components/ReportIconList';
import WReportDetailTable from './components/ReportDetailTable';

export default {
  name: 'WReportListView',
  mixins: [ScrollbarMixin],
  components: {
    WReportIconList,
    WReportDetailTable,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      orderType: 'count',
      viewType: 'icon',
      searchValue: '',
      reportSearchValue: '',
      showSearchTool: false,
    };
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    changeView() {
    },
    deleteReport() {
      const currentView = this.$refs[`${this.viewType}View`];
      const selectedReportList = currentView.getSelectedReportList(); // 선택된 레포트 리스트
      const target = '보고서';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        reportApi.deleteReport(selectedReportList).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.$emit('load-tree-data');
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    searchReport() {
      this.reportSearchValue = this.searchValue;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/template/list/index.vue